export default __webpack_public_path__ + "img/8ed86a493211a5aea223f0ce52a91904.jpg";